export default "assets/images/textures-78ef67be.jpg";